import {InMemoryDbService, RequestInfo, ResponseOptions} from "angular-in-memory-web-api";
import {Observable} from "rxjs/index";
import {Injectable, Injector} from "@angular/core";
import {DX_API_MOCKS, DX_IN_MEMORY_BACKEND_CONFIG} from "../config/dx-in-memory-backend-config";


@Injectable()
export class DxInMemoryDB extends InMemoryDbService {
  private readonly _db: any = {};

  // TODO: Понять почему не работает такой способ инжектирования:
  // TODO: @Inject(DX_IN_MEMORY_BACKEND_CONFIG)
  constructor(private _injector: Injector) {
    super();
    this._db = {};
    const config = this._injector.get(DX_IN_MEMORY_BACKEND_CONFIG);
    const apiMocks = this._injector.get(DX_API_MOCKS);
    if(apiMocks) {
      this._db = this._initDB(apiMocks);
    }
  }

  public createDb(reqInfo?: RequestInfo): {} | Observable<{}> | Promise<{}> {
    return this._db;
  }

  /** Метод позволяет модифировать респонс от ин-мемори бэкэнда **/
  protected responseInterceptor(res: ResponseOptions, ri: RequestInfo): ResponseOptions {
    return res;
  }

  private _initDB(mocks: Map<string, any[]>): any {
    let result = {};
    mocks.forEach((value, key) => {
      result[key] = [...value];
    });
    return result;
  }
}
